import { ActivatedRoute } from "@angular/router";
import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { getApp } from "../app";
import { Subscription } from "rxjs";
import { Customer } from "../../../../shared/types/customers";
import { hasChanges } from "../utils/app.utils";

@Component({
    selector: "app-profile",
    templateUrl: "./profile.component.html",
    styleUrls: ["./profile.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProfileComponent implements OnInit, OnDestroy {
  @ViewChild("fileInput", { static: false }) fileInput: any;
  @ViewChild("discardChangesModal", { static: true })
  discardChangesModal: any;
  profileId = "";
  fullName: any;

  private _routeSubscription: Subscription = new Subscription();

  app = getApp((app) => {
    this.app = app;
  });

  personProfileFields: string[] = [];

  constructor(private route: ActivatedRoute) {}

  async ngOnInit() {
    this.personProfileFields = this.app.list.personProfile.personProfile;
    this._routeSubscription = this.route.params.subscribe(async (params) => {
      this.profileId = params.user;
      await this.app.profile.getProfile(this.profileId);

      this.app.profile.loadProfileModelWithSections();

      this.app.profile.userProfilePicture =
        await this.app.profile.getProfilePicture(this.profileId);

      this.fullName =
        this.app.profile.profileWithSections[
          "personProfile.Titel Vorname Nachname"
        ] +
        " " +
        this.app.profile.profileWithSections["personProfile.LastName"];
      if (this.app.customers.expectCurrent === Customer.OC) {
        this.app.OCHome.setBadgeSystem();
        if (!this.app.auth.isAdmin) {
          this.personProfileFields.splice(
            this.personProfileFields.indexOf("personProfile.Management", 1)
          );
        }
      }

      if (!this.app.profile.viewProfile) {
        await this.app.userSettings.getCurrentUserSettings(this.profileId);
        this.app.userSettings.getCustomerEmailsList();
      }
      this.app.spinner.hideSpinner();
    });
  }

  get name(): string {
    const profileUser = this.app.profile.profile.name;
    if (profileUser != null) {
      return profileUser;
    }
    return this.app.expectUser;
  }

  get own() {
    return this.name === this.app.user;
  }

  checkPermissions(name: string) {
    switch (this.app.customers.expectCurrent) {
      case Customer.OC:
        return this.app.permission.user.manageProfile;
      default:
        if (name !== this.app.user) {
          return false;
        } else {
          return true;
        }
    }
  }

  modelHasChanges() {
    return hasChanges(
      this.app.profile.profileWithSections,
      this.app.profile.cleanProfileWithSections
    );
  }

  async onUpload() {
    const file: File = this.fileInput.nativeElement.files[0];
    this.app.profile.uploadProfilePicture(file);
  }

  async onDelete() {
    await this.app.profile.deleteProfilePicture();
    this.fileInput.nativeElement.value = "";
  }

  dismissModal() {
    if (this.modelHasChanges()) {
      this.discardChangesModal.open();
    } else {
      this.app.unlockedId = null;
      this.app.field.inputSubject.next(true);
    }
  }

  discardDetails() {
    this.app.unlockedId = null;
    this.app.profile.profileWithSections = Object.assign(
      {},
      this.app.profile.cleanProfileWithSections
    );

    this.app.userSettings.currentUserEmailPreferences = [
      ...this.app.userSettings.cleanUserEmailPreferences,
    ];
  }

  showEmailsBox() {
    // Read mode
    if (
      (this.app.auth.isAdmin &&
        this.app.customers.expectCurrent === Customer.OC) ||
      (this.app.users.currentUser._id === this.app.state.userId &&
        this.app.permission.userSettings.editOwn)
    ) {
      return true;
    }
    return false;
  }

  ngOnDestroy(): void {
    if (this._routeSubscription) {
      this._routeSubscription.unsubscribe();
      this.app.profile.loadProfileModelWithSections();
    }
  }
}
